var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSideNo3 = function SvgSideNo3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sideNO_3_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sideNO_3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4BB44",
    d: "M2 21.906a1 1 0 0 0 1.496.868l8.482-4.847a1 1 0 0 1 1.03.023l7.458 4.71A1 1 0 0 0 22 21.815V1.629a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m15.14 4.444-2.58 3.435q.735.12 1.358.412.622.293 1.072.765t.697 1.125.248 1.478q0 .855-.293 1.582-.292.728-.854 1.253t-1.396.81-1.897.27q-.345 0-.772-.113-.428-.112-.87-.3-.443-.187-.84-.435-.398-.247-.683-.532v-2.4q.135.315.525.63t.862.562.953.398.825.15q.945 0 1.5-.473.555-.472.555-1.462 0-.765-.398-1.268-.397-.502-.99-.825-.592-.322-1.275-.51-.682-.187-1.252-.337H9.62l2.13-2.88H8.735V4.444z"
  }))));
};
export default SvgSideNo3;